export default __webpack_public_path__ + "static/sashFlat1ColorDphBluePms281White-09b2baf8617ee3757f7b97d443d9232a.png";